import {PlantStructureTabs} from '@hconnect/common/enums'
import {useLayoutEffect, useMemo} from 'react'

import {useUrlParam} from '../routing'

import {
  CrusherFlowContainer,
  General,
  Kpis,
  Layout,
  OperationModes,
  Sensors,
  StandardTimes,
  Configuration,
  Connection,
  Optimizer,
  BaseLoad,
  GrindingCircuits,
  Admin,
  HeatZones,
  DrillingZones
} from './plant-setup-tabs'
import {useItemDetails, useSelectedItem} from './providers'

export const ItemDetails = () => {
  const {selectedItem} = useSelectedItem()
  const {selectedTab, availableTabs, handleTabChange} = useItemDetails()

  const nodeTabFromUrl = useUrlParam('nodeTab')
  const headerTabFromUrl = availableTabs.find(({value}) => value === nodeTabFromUrl)

  const tabComponentMap = useMemo(
    () => ({
      [PlantStructureTabs.General]: General,
      [PlantStructureTabs.Configuration]: Configuration,
      [PlantStructureTabs.CrusherFlow]: CrusherFlowContainer,
      [PlantStructureTabs.Admin]: Admin,
      [PlantStructureTabs.Layout]: Layout,
      [PlantStructureTabs.HeatZones]: HeatZones,
      [PlantStructureTabs.DrillingZones]: DrillingZones,
      [PlantStructureTabs.Sensors]: Sensors,
      [PlantStructureTabs.Kpis]: Kpis,
      [PlantStructureTabs.GrindingCircuits]: GrindingCircuits,
      [PlantStructureTabs.BaseLoad]: BaseLoad,
      [PlantStructureTabs.OperationModes]: OperationModes,
      [PlantStructureTabs.StandardTimes]: StandardTimes,
      [PlantStructureTabs.Optimizer]: Optimizer,
      [PlantStructureTabs.Connection]: Connection
    }),
    []
  )

  const TabContentComponent = useMemo(() => {
    if (!selectedTab) return () => null

    const Component = tabComponentMap[selectedTab.value as PlantStructureTabs]

    if (!Component) {
      throw new Error(`BUG: Unknown tab value: ${selectedTab.value}`)
    }

    return Component
  }, [selectedTab, tabComponentMap])

  useLayoutEffect(() => {
    headerTabFromUrl ? handleTabChange(headerTabFromUrl) : handleTabChange(availableTabs[0])
  }, [availableTabs, nodeTabFromUrl, headerTabFromUrl, handleTabChange])

  return selectedItem ? (
    <TabContentComponent key={selectedItem.upmId} selectedItem={selectedItem} />
  ) : null
}
